var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-shuffle",on:{"click":_vm.shuffle}},[_vm._v("\n  クイズをシャッフルする\n")])}
var staticRenderFns = []

export { render, staticRenderFns }